import axiosClient from "./axiosClient";
import { IRoleInterfaceDTO } from "@interfaces/IRoleInterfaceDTO";
import { IPermissionDTO } from "@interfaces/IPermissionDTO";
function normalizeRole(
  role: Partial<IRoleInterfaceDTO> & { id: number; name: string },
  roleGroupId: number
): IRoleInterfaceDTO {
  return {
    id: role.id,
    name: role.name,
    role_group_id:
      typeof role.role_group_id === "number" ? role.role_group_id : roleGroupId,
  };
}

const RoleService = {
  fetchRolesByRoleGroup(roleGroupId: number): Promise<IRoleInterfaceDTO[]> {
    return axiosClient
      .get<Array<{ id: number; name: string }>>(
        `/role_api/roles/role_group/${roleGroupId}`
      )
      .then((res) => res.data.map((r) => normalizeRole(r, roleGroupId)));
  },

  fetchRole(roleId: number, roleGroupId: number): Promise<IRoleInterfaceDTO> {
    return axiosClient
      .get<Partial<IRoleInterfaceDTO> & { id: number; name: string }>(
        `/role_api/role/${roleId}`
      )
      .then((res) => normalizeRole(res.data, roleGroupId));
  },

  fetchAllRoles(roleGroupId: number): Promise<IRoleInterfaceDTO[]> {
    return axiosClient
      .get<Array<Partial<IRoleInterfaceDTO> & { id: number; name: string }>>(
        `/role_api/roles`
      )
      .then((res) => res.data.map((r) => normalizeRole(r, roleGroupId)));
  },
  fetchAllRolesForPermissions(roleGroupId: number): Promise<IPermissionDTO[]> {
    return axiosClient
      .get<Array<Partial<IPermissionDTO> & { id: number; name: string }>>(
        `/role_api/all/permissions/${roleGroupId}`
      )
      .then((res) => res.data as IPermissionDTO[]);
  },
  editPermissions(sendData: IPermissionDTO[]): Promise<null> {
    return axiosClient
      .post(`/role_api/update/permissions`, { permissions: sendData })
      .then(() => null);
  },
};

export default RoleService;
